import React from 'react'
import { useEffect as uEffect, useState as uState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import Sidebar from '../../components/sidebar/Sidebar';
import Navbar from '../../components/navbar/Navbar';

export default function systemHealth() {
    const startTime = window.performance.now();    
    const [memoryUsage, setMemoryUsage] = uState(null);
    uEffect(() => {
        if (window.performance && window.performance.memory) {
            setMemoryUsage(window.performance.memory.usedJSHeapSize / 1024 / 1024);
        }

    }, []);
    const data = [
        {
            name: 'Memory',
            memory: memoryUsage,
        }
    ]
    const endTime = window.performance.now();
    const timeTaken = endTime - startTime;

    const data1 = [
        {
            name: 'Time',
            time: timeTaken,
        }
    ]

    return (
        <>
            <div className="home">
                <Sidebar />
                <div className="homeContainer">
                    <Navbar />
                    <div className="charts">
                        <BarChart width={330} height={250} data={data}
                            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                            <XAxis dataKey="name" />
                            <YAxis />
                            <CartesianGrid strokeDasharray="3 3" />
                            <Tooltip />
                            <Bar type="monotone" dataKey="memory" fillOpacity={1} fill="#8884d8" />
                        </BarChart>

                        <BarChart width={330} height={250} data={data1}
                            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                            <XAxis dataKey="name" />
                            <YAxis />
                            <CartesianGrid strokeDasharray="3 3" />
                            <Tooltip />
                            <Bar type="monotone" dataKey="time" fillOpacity={1} fill="#8884d8" />
                        </BarChart>
                    </div>
                </div>
            </div>
            <div className='chart d-flex'>

            </div>
      </>
  )
}
